import { styled, Switch } from '@mui/material';
import { omit } from 'lodash';
import { forwardRef, useState } from 'react';

const CustomSwitch = styled(Switch)(({ theme, isFocused }) => {
    return {
        borderRadius: '100px',
        width: '52px',
        height: '28px',
        padding: 0,
        '& > .MuiSwitch-switchBase': {
            left: '4px',
            margin: theme.spacing(1, 0),
            width: '20px',
            height: '20px',
            padding: 0,
            '&.Mui-checked': {
                color: theme.palette.ensightful.shades[0],
                transform: 'translateX(24px)',
            },
        },
        '& > .MuiSwitch-track': {
            background: theme.palette.ensightful.neutral[500],
            opacity: '1 !important',
        },
        '& > .MuiSwitch-switchBase.Mui-disabled + .MuiSwitch-track': {
            background: theme.palette.ensightful.neutral[400],
        },
        '& > .MuiSwitch-switchBase.Mui-checked.Mui-disabled + .MuiSwitch-track': {
            background: theme.palette.ensightful.primary[100],
        },
        ...(isFocused && {
            outline: `${theme.palette.ensightful.secondary[400]} solid 3px`,
            outlineOffset: '4px',
        }),
    };
});

export default forwardRef(({ ...rest }, ref) => {
    const [isFocused, setIsFocused] = useState(false);

    return (
        <CustomSwitch
            ref={ref}
            aria-disabled={undefined}
            inputProps={{
                'aria-label': rest['aria-label'],
                'aria-labelledby': rest['aria-labelledby'],
                ...rest.inputProps,
            }}
            {...omit(rest, ['aria-labelledby'])}
            isFocused={isFocused}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
        />
    );
});
